'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('attrsbenchmark', {
      url: '/attrsbenchmark',
      template: '<attrsbenchmark></attrsbenchmark>'
    });
}
